const generatePath = (path: string, params) => {
  let processedRoute = path.toString()
  let processingParams = Object.assign({}, params)

  Object.keys(params).forEach(key => {
    const replaceKey = `:${key}`
    const keyValue = processingParams[key]

    if (processedRoute.includes(replaceKey)) {
      processedRoute = processedRoute.replace(new RegExp(replaceKey, 'g'), keyValue)

      // Remove the key if found and replaced
      delete processingParams[key]
    }
  })

  if (Object.keys(processingParams).length > 0) {
    return `${processedRoute}?${encodeQueryData(processingParams)}`
  } else {
    return processedRoute
  }
}

const encodeQueryData = (data: object): string => {
  let ret = [];
  for (let d in data) {
    if (data[d] !== null) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
  }
  return ret.join('&');
}

export {
  generatePath
}